module.exports = __webpack_public_path__ + "static/media/register-warehouse-button-icon.c11e9e60.svg";